<template>
  <div>
    <dafault-header class="noprint"></dafault-header>
    <div id="wrapper">
      <div class="content">
        <div class="home-map fl-wrap">
          <div class="map-container fw-map" id="wastemap">
            <base-map
              ref="mapRef"
              :markers="szurtBejegyzesekMarkers"
              :markerKey="'Id'"
              :selectedData.sync="mapSelected"
              v-if="defer(10)"
            >
              <template v-slot:infoWinData="{ infoWinData }">
                <a href="javascript:;" class="listing-img-content fl-wrap">
                  <img :src="infoWinData.Image" alt="" />
                </a>
                <div class="listing-content fl-wrap">
                  <div class="listing-title fl-wrap text-left">
                    <div class="row mb-4 no-gutters">
                      <div class="col-7 px-0" v-if="infoWinData.Locality">
                        <a class="map-item scroll-top-map pointer text-nowrap">
                          <k-icon name="fa-map-marker-alt"></k-icon>
                          <span class="adat_hely">
                            {{ infoWinData.Locality }}
                          </span>
                        </a>
                      </div>
                      <div
                        class="col-5 px-0 text-nowrap"
                        :class="{ 'text-right': infoWinData.Locality }"
                      >
                        <k-icon name="fa-calendar-alt"></k-icon>
                        <span class="adat_hely">
                          {{ infoWinData.Created | toShortDate }}
                        </span>
                      </div>
                    </div>
                    <div class="d-inline-flex ikonok noprint">
                      <bejegyzes-ikonok
                        class="d-flex flex-wrap justify-content-start flex-row"
                        :bejegyzesIcons="infoWinData.Types"
                        :iconText="true"
                      ></bejegyzes-ikonok>
                      <bejegyzes-ikonok
                        :bejegyzesIcons="[infoWinData.Size]"
                        :iconText="true"
                        class=""
                      ></bejegyzes-ikonok>
                    </div>
                  </div>
                </div>
              </template>
            </base-map>
          </div>
        </div>
        <pdf-additional-data
          ref="pdfAdditionalData"
          :mapSelected="mapSelected"
        ></pdf-additional-data>
        <div class="content noprint">
          <!-- Fő szűrők -->
          <section class="no-pading pt-0">
            <div class="intro-item fl-wrap py-20" id="ElemzesSzuro2">
              <szuro-badgek
                class="mb-5"
                ref="szuroBadgekContainer"
                :badgek="szurokBejegyzesek"
                :selected.sync="selectedSzurok"
                mapObj="fo"
              >
              </szuro-badgek>
            </div>
          </section>

          <section class="gray-bg no-pading no-top-padding" id="sec3">
            <div
              class="col-list-wrap fh-col-list-wrap center-col-list-wrap left-list mb-20"
            >
              <div class="container">
                <div class="row">
                  <!-- Járművek -->
                  <div class="col-12">
                    <div class="listsearch-header fl-wrap">
                      <h3>
                        <span id="jarmuCount">{{
                          szurtBejegyzesek.length
                        }}</span>
                        <span> {{ $t('ui_garbagePile') }}</span>
                      </h3>

                      <div class="listing-view-layout d-block">
                        <ul>
                          <li>
                            <a
                              class="grid active"
                              href="javascript:;"
                              @click="ExportList"
                              v-b-tooltip.hover
                              title="Excel export"
                              ><i class="fa fa-file-excel"></i
                            ></a>
                          </li>
                          <li>
                            <a
                              class="grid"
                              :class="{ active: listLayout == true }"
                              href="javascript:;"
                              @click="listLayout = false"
                              v-b-tooltip.hover
                              title="Táblázatos nézet"
                              ><i class="fa fa-th-large"></i
                            ></a>
                          </li>

                          <li>
                            <a
                              class="list"
                              :class="{ active: listLayout == false }"
                              href="javascript:;"
                              @click="listLayout = true"
                              v-b-tooltip.hover
                              title="Lista nézet"
                              ><i class="fa fa-list-ul"></i
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      class="list-main-wrap fl-wrap card-listing pt-20"
                      v-if="defer(2)"
                    >
                      <table-with-pagination
                        :items="szurtBejegyzesek"
                        :searchStr.sync="keresesStr"
                      >
                        <template v-slot:default="{ items }">
                          <div class="d-flex flex-wrap">
                            <div
                              v-for="bejegyzes in items"
                              :key="bejegyzes.JarmuId"
                              class="listing-item d-flex"
                              :class="[listLayout == true ? 'list-layout' : '']"
                            >
                              <bejegyzes-info
                                class="w-100"
                                :bejegyzes="bejegyzes"
                                :listLayout="listLayout"
                                @Terkepre="
                                  ShowOnMap(
                                    $event.latitude,
                                    $event.longitude,
                                    $event.id
                                  )
                                "
                              >
                              </bejegyzes-info>
                            </div>
                          </div>
                        </template>
                      </table-with-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <default-footer class="noprint" id="contact"></default-footer>
  </div>
</template>

<script>
import { sendToSocket } from '../utils/socketConnection';
import { apiService, eventBus, tisztaTisza } from '../main';
import { SzuroFunctions } from '../functions/SzuroFunctions';
import { mapGetters } from 'vuex';
import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';
import pick from 'lodash/pick';
import { gmapApi } from 'vue2-google-maps';
import { AppStoreTypes } from '../store/modules/app';
import { date } from 'jszip/lib/defaults';
import { sortStr } from '../utils/sort';
import { escapeRegExp, safeGetProp, timeout } from '../utils/common';
import DeferMixin from '../mixins/Defer';
import { BejegyzesStoreTypes } from '../store/modules/bejegyzes';
import { Statuszok } from '../data/enums/kodszotar/statuszok';
import { TisztaTiszaFunctions } from '../functions/TisztaTiszaFunctions';

export default {
  name: 'dashboard',
  components: {},
  metaInfo: {
    titleTemplate: () => {
      return tisztaTisza.$t('ui_htmlTitle');
    },
    meta: [
      {
        name: 'description',
        content:
          'A Tiszta Tisza Térkép a folyó és mellékfolyóinak hulladékhelyzetét mutatja be. Minél jobban ismerjük a szennyezés gócpontjait, annál hatékonyabban léphetünk fel a szennyezés felszámolása érdekében. A Tisza országokat köt össze, csak közösen, együttes erővel tehetjük újra tisztává!',
      },
    ],
  },
  data: function() {
    return {
      selectedSzurok: [
        {
          key: 'NearbyRiverriver_Tisza',
          value: {
            Id: 'river_Tisza',
            Nev: 'river_Tisza',
            count: 2,
            szuro: {
              propId: 'NearbyRiver',
              propNev: 'NearbyRiver',
              order: 0,
              mapObj: 'fo',
              class: 'trs-btn',
              tooltip: 'NearbyRiver',
              i18n: true,
            },
            selected: 0,
          },
        },
      ],
      selectedJarmuTablazatban: null,
      selectedCelIntezetId: null,
      isFogvatartottIntezetekVisible: false,
      isFogvatartottIntezetekKuldoVisible: false,
      selectedCelIntezet: null,
      selectedFogadoIntezet: null,
      keresesStr: '',
      mounted: false,
      mapSelected: null,
      listLayout: false,
      terkepInfoModalSeen: false,
    };
  },
  async mounted() {
    // this.terkepInfoModalSeen = this.TerkepInfoModalSeen();
    // if (this.terkepInfoModalSeen == false) {
    //   await timeout(500);
    //   this.OpenTerkepInfoModal();
    // }
    await timeout(250);
    // this.OpenTerkepInfoModal();
    this.mounted = true;
    window.FB.init({ xfbml: true, version: 'v7.0' });
  },
  methods: {
    ShowOnMap(latitude, longitude, id) {
      this.$refs.mapRef.SetZoom(9);

      // OpenInfoWindow magátol odamegy
      //this.$refs.szallitasKovetesMap.MoveToPos(latitude, longitude);
      this.$refs.mapRef.OpenInfoWindow(id);
    },
    ExportList() {
      TisztaTiszaFunctions.ExcelExportBejegyzesek(
        this.szurtBejegyzesek,
        this.$t.bind(this)
      );
    },
    OpenTerkepInfoModal() {
      eventBus.$emit('Modal:terkep-info-modal');
    },
    // TerkepInfoModalSeen() {
    //   let hours = 24;
    //   let saved = localStorage.getItem('terkep-info-modal-seen');
    //   if (!saved) {
    //     localStorage.setItem(
    //       'terkep-info-modal-seen',
    //       new Date().toISOString()
    //     );
    //     return false;
    //   }

    //   if (new Date() - new Date(saved) > hours * 60 * 60 * 1000) {
    //     localStorage.setItem(
    //       'terkep-info-modal-seen',
    //       new Date().toISOString()
    //     );
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
  },
  computed: {
    ...mapGetters({
      bejegyzesek: BejegyzesStoreTypes.bejegyzesek.getAll,
    }),
    google: gmapApi,
    szuroProps() {
      let props = [
        {
          propId: 'Status',
          propNev: 'Status',
          order: 1,
          mapObj: 'fo',
          class: 'status-btn',
          tooltip: 'Státusz',
          i18n: true,
        },
        {
          propId: 'Size',
          propNev: 'Size',
          order: 2,
          mapObj: 'fo',
          class: 'types-btn',
          tooltip: 'Méret',
          i18n: true,
        },
        {
          propId: 'Types',
          propNev: 'Types',
          order: 3,
          mapObj: 'fo',
          class: 'fogv-badge',
          tooltip: 'Típus',
          i18n: true,
        },
        {
          propId: 'NearbyRiver',
          propNev: 'NearbyRiver',
          order: 0,
          mapObj: 'fo',
          class: 'trs-btn',
          tooltip: 'NearbyRiver',
          i18n: true,
        },
        {
          propId: 'Accessibility',
          propNev: 'Accessibility',
          order: 4,
          mapObj: 'fo',
          class: 'hol-badge',
          tooltip: 'Megközelítés',
          i18n: true,
        },
      ];
      return props;
    },

    szurokBejegyzesek() {
      //console.log('szurokFogv - start');
      let bejegyzesek = this.szurtBejegyzesek;
      let szuroProps = this.szuroProps;
      let selectedSzurok = this.selectedSzurok;

      let szurok = SzuroFunctions.CreateSzurok(
        bejegyzesek,
        szuroProps,
        selectedSzurok
      );
      return szurok;
    },

    szurtBejegyzesek() {
      let bejegyzesek = this.bejegyzesek;
      var selectedSzurok = this.selectedSzurok.map(m => m.value);
      const regex = RegExp(escapeRegExp(this.keresesStr), 'ig');
      let szurtBejegyzesek = this.bejegyzesek.filter(m => {
        return (
          !SzuroFunctions.ValidateSzurok(selectedSzurok, m) &&
          TisztaTiszaFunctions.BejegyzesSzures(m, regex, this.$t.bind(this))
        );
      });

      function compare(a, b) {
        if (a.UpdateTime > b.UpdateTime) return -1;
        if (a.UpdateTime < b.UpdateTime) return 1;
        return 0;
      }
      return szurtBejegyzesek.sort(compare);
    },
    szurtBejegyzesekMarkers() {
      if (!this.google) {
        return [];
      }
      let bejegyzesek = this.bejegyzesek;

      let szurtBejegyzesekDict = keyBy(this.szurtBejegyzesek, 'Id');

      let result = bejegyzesek
        .filter(f => f.Latitude && f.Longitude)
        .map(m => {
          return {
            position: new this.google.maps.LatLng(m.Latitude, m.Longitude),
            icon: {
              anchor: new this.google.maps.Point(25, 50),
              url:
                m.Status == Statuszok.Cleaned
                  ? require('../assets/images/marker-green.png')
                  : require('../assets/images/marker.png'),
            },
            id: m.Id,
            data: m,
            visible: szurtBejegyzesekDict[m.Id] != null,
          };
        });
      return result;
    },
  },
  watch: {},
  mixins: [DeferMixin(10)],
};
</script>
<style scoped>
.accordion a.toggle i {
  top: 12px;
}

.map-popup .listing-img-content {
  width: 100%;
  height: 182px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.map-popup img {
  height: 100%;
  object-fit: cover;
  object-position: center right;
}
.map-popup .ikonok {
  max-width: 100%;
  width: max-content;
  max-height: 150px;
  overflow-x: hidden;
}
</style>
